// src/security/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const PrivateRoute = ({ children }) => {
  const token = Cookies.get("accessToken");

  if (!token) {
    // 🔒 Si no hay token, redirigir a login
    return <Navigate to="/" replace />;
  }

  // ✅ Token presente, permitir acceso
  return children;
};

export default PrivateRoute;
